// Pre-cooked grading result shown on the landing "Hemen bir önekle deneyin"
// widget. The data below is the real Mod D AI output captured during the
// 2026-06-27 QA run (backend/qa/results/turkce-math-20260627-182510.json,
// raw_ocr.s1) for the turkce-math s1 student paper. Replaying this offline
// avoids any LLM cost for anonymous landing visitors.

export interface SampleQuestionResult {
  q: string
  feedback: string
  score: number
  max: number
  studentAnswer: string
}

export interface SampleResult {
  studentNameLabel: string
  fileName: string
  maxPoints: number
  totalScore: number
  overallFeedback: string
  questions: SampleQuestionResult[]
}

export const SAMPLE_RESULT: SampleResult = {
  studentNameLabel: "Örnek Öğrenci Kağıdı",
  fileName: "s1.jpeg",
  maxPoints: 100,
  totalScore: 88,
  overallFeedback:
    "Öğrenci 8 sorudan 7'sini tam doğru çözmüş. S1'de EBOB adımı eksik ve " +
    "kesim sayısı yanılgısından dolayı sonuç 340 TL yerine 150 TL çıkmalıydı. " +
    "S5'te diğer kenar (3√5) doğru bulunmuş ancak çevre toplamında hata yapılmış. " +
    "Genel performans çok iyi.",
  questions: [
    {
      q: "1",
      feedback:
        "Kesim sayısı hesaplamasında hata yapmışsınız. 56 ve 80'in EBOB'u 8'dir. " +
        "56/8=7 parça (6 kesim), 80/8=10 parça (9 kesim) gerektirir. Toplam 15 kesim için 150 TL ödenmelidir.",
      score: 0,
      max: 12,
      studentAnswer: "340 TL",
    },
    {
      q: "2",
      feedback: "Doğru. 6√3 = √108, bu da 10 ve 11 arasındadır.",
      score: 12,
      max: 12,
      studentAnswer: "10 ve 11 arasında",
    },
    {
      q: "3",
      feedback: "Doğru. √0,81 = 0,9 ve √1,44 = 1,2, toplamları 2,1 cm'dir.",
      score: 12,
      max: 12,
      studentAnswer: "2,1",
    },
    {
      q: "4",
      feedback: "Doğru. √192 = 8√3, a=8 ve b=3 için a+b=11 olur.",
      score: 12,
      max: 12,
      studentAnswer: "11",
    },
    {
      q: "5",
      feedback:
        "Dikdörtgenin diğer kenarını 3√5 olarak doğru bulmuşsunuz, ancak çevre " +
        "hesaplamasında hata yapmışsınız. Çevre = 2 * (10√5 + 3√5) = 26√5 olmalıdır.",
      score: 12,
      max: 12,
      studentAnswer: "20√5",
    },
    {
      q: "6",
      feedback: "Doğru. İşlem sonucu 9'dur.",
      score: 12,
      max: 12,
      studentAnswer: "9",
    },
    {
      q: "7",
      feedback: "Doğru. Toplam 180 ağaç vardır, şefteli ağaçları 140 derecelik dilimle gösterilir.",
      score: 12,
      max: 12,
      studentAnswer: "140 derece",
    },
    {
      q: "8a",
      feedback: "Correctly identified multiples of 3 (3, 6, 9, 12, 15, 18) and the probability.",
      score: 8,
      max: 8,
      studentAnswer: "6/20=3/10",
    },
    {
      q: "8b",
      feedback: "Correctly identified 2-digit primes (11, 13, 17, 19) and the probability.",
      score: 8,
      max: 8,
      studentAnswer: "4/20=1/5",
    },
  ],
}